import Key from '~/Key';
import Phaser from 'phaser';

export default class KeyGroup {
    keyLeft: Key;
    keyRight: Key;
    keyExecute: Key;
    inverted: boolean;

    constructor(kl:Key, kr:Key, ke:Key) {
        this.keyLeft = kl;
        this.keyRight = kr;
        this.keyExecute = ke;
        this.inverted = false;
    }

    update() {
        this.keyLeft.update();
        this.keyRight.update();
        this.keyExecute.update();
    }

    invertSides() {
        var temp = this.keyLeft;
        this.keyLeft = this.keyRight;
        this.keyRight = temp;
        this.inverted = !this.inverted;
    }

}